import { RenderedAiIcon } from '@assets/logos';
import { Group } from '@components/layout';
import { InternalLink } from '@components/link';
import { Typography } from '@components/typography';
import { Stack } from '@mui/material';
import { useOrganizationContext } from '@navigation/OrganizationContext';
import { SystemNotificationBanner } from '@subsets/system/SystemNotificationBanner';
import { ThemeToggle } from '@theme/ThemeToggle';
import { AgentChatToggle } from './AgentChatToggle';
import { Help } from './Help';
import { OrganizationDisplay } from './OrganizationDisplay';
import { Profile } from './Profile';

export const Header = ({ hideProduct }: { hideProduct?: boolean }) => {
  const { organization } = useOrganizationContext();
  const agentOrg = organization?.serviceOnly;
  return (
    <BaseHeader
      leftContent={hideProduct ? null : <ProductDisplay agentOrg={agentOrg} />}
      rightContent={
        <Group alignItems="center" zIndex={1} height="100%" gap={4}>
          <OrganizationDisplay />
          <Group alignItems="center" zIndex={1} height="100%" gap="2px">
            {process.env.GATSBY_ENV === 'dev' && <ThemeToggle />}
            {agentOrg && <AgentChatToggle />}
            <Help />
            <Profile />
          </Group>
        </Group>
      }
    />
  );
};

const ProductDisplay = ({ agentOrg }: { agentOrg: boolean }) => {
  return (
    <Typography variant="body2" color="grey.300">
      {agentOrg ? 'Agent studio' : 'Synthetic data studio'}
    </Typography>
  );
};

export const BaseHeader = ({
  leftContent,
  centerContent,
  rightContent,
}: {
  leftContent?: React.ReactNode;
  centerContent?: React.ReactNode;
  rightContent?: React.ReactNode;
}) => {
  return (
    <Stack sx={{ gridColumn: '1 / -1', minHeight: '48px' }}>
      <header
        style={{
          backgroundColor: 'black',
          height: '48px',
          minHeight: '48px',
          paddingLeft: '16px',
          paddingRight: '16px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{ display: 'flex', alignItems: 'center', zIndex: 1, height: '100%', gap: '16px' }}
        >
          <InternalLink to="/" style={{ display: 'flex', justifyContent: 'center' }}>
            <RenderedAiIcon size={28} style={{ cursor: 'pointer' }} />
          </InternalLink>
          {leftContent}
        </div>
        {centerContent}
        {rightContent}
      </header>
      <SystemNotificationBanner />
    </Stack>
  );
};
